import { useQuery } from '@tanstack/react-query';
import { ambientApi, logger } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export const FallbackDemoConversation: Record<string, string>[] = [
  { You: 'Hi, what brings you to the emergency room today?' },
  {
    Patient:
      "I've been having severe back pain for the past few hours. It's so intense that I can barely move.",
  },
  {
    You: "We need to act quickly. We'll take some blood tests and do an MRI to check what's causing the pain. Have you had any previous back issues?",
  },
  { You: 'No, this is the first time.' },
  {
    You: "Alright. The MRI shows a herniated disc pressing on a nerve, which is causing the severe pain. We're going to give you some pain relief medication and a muscle relaxant to stabilize you. You'll be admitted to the orthopedic unit for close monitoring and to discuss further treatment options, which may include physical therapy or, if necessary, surgery.",
  },
  { Patient: 'Thanks doc.' },
];

type GetSpecialtyDemoConversationResponse = {
  onboarding_script_id: number;
  script: {
    conversation: typeof FallbackDemoConversation;
  };
  specialty_id: number;
  specialty_name: string;
};

export const useGetSpecialtyDemoConversation = (
  {} = {},
  options: UseQueryOverrideOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['specialtyDemoConversation'],
    queryFn: () =>
      ambientApi
        .get<GetSpecialtyDemoConversationResponse>('/onboarding/specialty')
        .then((res) => res.data?.script?.conversation)
        .catch((err) => {
          logger.error('Failed to fetch specialty demo conversation');
          throw err;
        }),
  });
};
